import { createFileRoute } from "@tanstack/react-router"

import { GuidePage } from "../components/landing"
import { rateGuide } from "../content/cents-per-km-calculator"
import { guideSeo } from "./guides.$slug"

const PATH = "/cents-per-km-calculator"

/** ATO rate and calculator page (T398); the content is a `Guide`, the URL is top level (copy-products.md). */
export const centsPerKmCalculatorSeo = () => guideSeo(rateGuide, PATH)

export const Route = createFileRoute("/_brand-layout/cents-per-km-calculator")({
  head: () => {
    const { meta, links, scripts } = centsPerKmCalculatorSeo()
    return { meta, links, scripts }
  },
  component: () => <GuidePage guide={rateGuide} />,
})
